import { Box } from '@mui/material';
import { useContext } from 'react';
import { Outlet } from 'react-router';

import { AppContext } from '../../app/context';

import Footer from './footer';
import Header from './header';

function Layout(): React.JSX.Element {
  const {
    app: { footerDisplayed },
  } = useContext(AppContext);

  return (
    <>
      <Header />
      <Box bgcolor="#f6f8fc" display="flex" flexDirection="column" minHeight="100svh" width="100%">
        <Outlet />
      </Box>
      {footerDisplayed && <Footer />}
    </>
  );
}

export default Layout;
